<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="(page) => onLoad(page, params)"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"> </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="toConsultDetail(scope.row)">
          咨询详情
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getOnlineConsult } from "@/api/health/manage";

export default {
  data() {
    return {
      username: window.localStorage.getItem("username"),
      channel: window.localStorage.getItem("channel"),
      params: {},
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        tip: false,
        border: true,
        index: true,
        indexLabel: "序号",
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        selection: true,
        searchMenuSpan: 4,
        column: [
          {
            label: "群聊编号",
            prop: "chatId",
            search: true,
            searchSpan: 4,
          },
          {
            label: "患者",
            prop: "name",
            search: true,
            searchSpan: 4,
          },
          {
            label: "医生",
            prop: "user_name",
            search: true,
            searchSpan: 4,
          },
          {
            label: "诊前咨询生成时间",
            prop: "create_time",
            // search: true
          },
        ],
      },
      data: [],
    };
  },
  computed: {},
  methods: {
    onLoad(page, params) {
      params.channel = window.localStorage.getItem("channel");
      params.userName = window.localStorage.getItem("username");
      getOnlineConsult(page.currentPage, page.pageSize, params).then((res) => {
        this.data = res.data.consult;
        this.page.total = res.data.total;
        console.log(res.data.consult);
      });
    },

    searchReset() {
      this.params.channel = window.localStorage.getItem("channel");
      this.params.userName = window.localStorage.getItem("username");
      this.page.currentPage = 1;
      this.onLoad(this.page, this.params);
    },

    searchChange(params, done) {
      params.channel = window.localStorage.getItem("channel");
      params.userName = window.localStorage.getItem("username");
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    toConsultDetail(row) {
      const parameter = {
        chatId: row.chatId,
        docId: row.docId,
      };
      this.$router.push({
        path: "/doctor/consultDetail",
        query: parameter,
      });
    },
  },
};
</script>
<style>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
